import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { IonContent } from '@ionic/angular/standalone';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.page.html',
  standalone: true,
  imports: [RouterLink, InlineSVGModule, TranslateModule, IonContent],
})
export class NotFoundPage implements OnInit {
  themeVersion: number;

  constructor(private router: Router) {}

  ngOnInit() {}
}
